var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": '/AbilityTreeFruit/' + _vm.id
    }
  }, [[_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "width": _vm.$size(),
      "height": _vm.$size()
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.itemicon.format(_vm.itemId) + '.jpg'
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "ml-0 mr-auto",
    staticStyle: {
      "max-width": "384px"
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.name))])], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }